var imgURL, posUrl, wsURL;
const online = 'https://sea.dnnbim.com/dev/dnnCloud/interface'
let baseURL = online
if (process.env.NODE_ENV == "development") {
  //baseURL = 'http://192.168.100.230:8080/dnnCloud/interface';

  // baseURL = 'http://192.168.20.230:8080/dnnCloud/interface';

  baseURL = "/api";
  // baseURL='http://192.168.20.55:8889/interface'

  //baseURL = 'http://192.168.100.219:8080/interface';
  //baseURL = 'https://dev.eicad.net/dnnCloud/interface';
  // baseURL = 'https://106.14.238.88:8080/dnnCloud/interface';
} else if (process.env.NODE_ENV == "test") {
  baseURL = "http://61.132.52.38:8001/dnnCloud/interface";
} else {
  // baseURL = 'http://106.14.238.88:8080/dnnCloud/interface';
  // baseURL = 'https://dev.eicad.net/dnnCloud/interface';
  // 海外
  baseURL == "https://sea.dnnbim.com/dev/dnnCloud/interface";

}
export { baseURL, wsURL, imgURL };



// WEBPACK FOOTER //
// ./src/api/config.js